/** Record the game's own canvas without requesting screen or microphone access. */
export function recordBattle(canvas: HTMLCanvasElement) {
  if (!canvas.captureStream || typeof MediaRecorder === 'undefined') {
    throw new Error('battle_video_unsupported');
  }
  const mimeType = ['video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm', 'video/mp4'].find((type) =>
    MediaRecorder.isTypeSupported(type)
  );
  if (!mimeType) throw new Error('battle_video_unsupported');
  const stream = canvas.captureStream(24);
  const chunks: BlobPart[] = [];
  let recorder: MediaRecorder;
  try {
    recorder = new MediaRecorder(stream, { mimeType, videoBitsPerSecond: 4000000 });
  } catch (error) {
    stream.getTracks().forEach((track) => track.stop());
    throw error;
  }
  let cancelled = false;
  let timedOut = false;
  let timer: ReturnType<typeof setTimeout>;
  const release = () => {
    clearTimeout(timer);
    stream.getTracks().forEach((track) => track.stop());
  };
  recorder.ondataavailable = (event) => {
    if (event.data.size) chunks.push(event.data);
  };
  const video = new Promise<Blob>((resolve, reject) => {
    recorder.onerror = () => {
      release();
      reject(new Error('battle_video_failed'));
    };
    recorder.onstop = () => {
      release();
      if (timedOut) return reject(new Error('battle_video_failed'));
      if (cancelled) return resolve(new Blob());
      const blob = new Blob(chunks, { type: mimeType });
      if (!blob.size) return reject(new Error('battle_video_failed'));
      resolve(blob);
    };
  });
  try {
    recorder.start(1000);
  } catch (error) {
    release();
    throw error;
  }
  // Release capture even if playback fails to reach its completion event.
  timer = setTimeout(() => {
    timedOut = true;
    recorder.stop();
  }, 10 * 60 * 1000);
  return {
    video,
    stop: () => {
      if (recorder.state !== 'inactive') recorder.stop();
    },
    cancel: () => {
      cancelled = true;
      if (recorder.state !== 'inactive') recorder.stop();
      release();
    },
  };
}

export function downloadBattleVideo(blob: Blob) {
  if (!blob.size) return;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `battle-${new Date().toISOString().replace(/[:.]/g, '-')}.${blob.type.includes('mp4') ? 'mp4' : 'webm'}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
